export const staticPillVariants = {
  NEUTRAL: 'neutral',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
} as const

export type StaticPillVariant =
  typeof staticPillVariants[keyof typeof staticPillVariants]
